import { render, staticRenderFns } from "./Replenishments.vue?vue&type=template&id=3ecb3cf3"
import script from "./Replenishments.vue?vue&type=script&lang=js"
export * from "./Replenishments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports